/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

/* global _paq */
import { accountService, loginService } from "../views/Auth/services";
import router from "../plugins/vue-router";
import { userService } from "../views/service/user.service";

const state = {
  user: {
    login: null,
    loggingIn: false,
    impersonate: false,
    switchAgence: false
  },
  userInfo: {},
  activateTour: false,
  currentStepRole: 1
};
const getters = {
  getCurrentStep: state => state.currentStepRole,
  loggedIn: state => state.user.loggingIn,
  getLogin: state => state.user.login,
  getSwitchAgence: state => state.user.switchAgence,
  getImpersonate: state => state.user.impersonate,
  getCurrentUser: state => state.userInfo,
  isActivateTour: state => state.activateTour
};
const actions = {
  authenticate({ dispatch, commit }, { login, password }) {
    commit("loginRequest", { login });

    const data = { login: login, password: password };
    loginService.login(data).then(
      () => {
        commit("loginSuccess", login);
      },
      error => {
        commit("loginFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },
  logoutAction({ commit }) {
    commit("logout");
    accountService.logout().then(result => {
      if (result) {
        router.router.push("/login", Function);
      }
    });
  },
  checkEmailToken({ dispatch, commit }, token) {
    accountService.checkTokenFirst(token).then(
      res => {
        commit("email", res.email);
        commit("activateTour", res.type);
      },
      err => {
        dispatch("alert/error", err, { root: true });
      }
    );
  },
  userInfoAction({ commit }) {
    return userService.fetchUserInfo(true).then(res => {
      commit("setUserInfo", res);
      if (window._paq) {
        // set matomo userId after login
        window._paq.push(["setUserId", res.email]);
      }
    });
  },
  changeCurrentStepAction({ commit }, current) {
    commit("changeCurrentStep", current);
  }
};
const mutations = {
  changeCurrentStep(state, current) {
    state.currentStepRole = current;
  },
  loginRequest(state, login) {
    state.user.login = login;
  },
  loginSuccess(state, login) {
    router.router.push("/", () => {
      state.user.loggingIn = true;
      state.user.login = login;
      state.user.username = login;
      state.user.switchAgence = true;
      console.log("account state switchAgence : " + state.user.switchAgence);
    });
  },
  email: (state, login) => (state.user.login = login),
  setLoggedIn: state => (state.user.loggingIn = true),
  setSwitchAgence: state => (state.user.switchAgence = false),
  setImpersonate: state => (state.user.impersonate = true),
  loginFailure(state) {
    state.user.loggingIn = false;
  },
  logout(state) {
    state.user = {
      login: null,
      username: null,
      loggingIn: false
    };
    state.activateTour = false;
  },
  setUserInfo: (state, userInfo) => (state.userInfo = userInfo),
  activateTour: (state, tokenType) =>
    (state.activateTour = tokenType === "SUBSCRIPTION")
};

export const account = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
